import { ActionType, Action, appointmentState } from "../actions/types"

const initialAppointmentState: appointmentState = {
  appointment: {
    type: "",
    details: [],
    matchingVisitDetails: { id: "", status: "" },
    smsMatchingVisitDetails: { id: "", status: "" },
    isNewSession: false
  }
}

const appointmentReducer = (
  state: appointmentState = initialAppointmentState,
  action: Action
) => {
  switch (action.type) {
    case ActionType.SET_APPOINTMENT:
      return {
        ...state,
        appointment: action.payload
      }
    default:
      return state
  }
}

export default appointmentReducer
